var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1632.000000, -2529.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-(1)",
    transform: "translate(1632.000000, 2529.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,512 L256,512 L256,336 L192,336 L192,256 L256,256 L256,192 C256,138.965333 298.965333,96 352,96 L416,96 L416,176 L384,176 C366.336,176 352,174.336 352,192 L352,256 L432,256 L400,336 L352,336 L352,512 L448,512 C483.285333,512 512,483.285333 512,448 L512,64 C512,28.6933333 483.285333,0 448,0 L64,0 C28.6933333,0 0,28.6933333 0,64 L0,448 C0,483.285333 28.6933333,512 64,512 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4453b35d6c460ccfce89368bec03625d.svg";
export { ForwardRef as ReactComponent };